var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-user-edit',{attrs:{"user":_vm.user},on:{"done":_vm.done,"ignored":_vm.ignored}})}
var staticRenderFns = []

export { render, staticRenderFns }